module.exports = __webpack_public_path__ + "img/watch-status.eafa61e7.svg";